<template>
  <div class="bg">
    <img src="../assets/login_bgpic.png" style="height: 100%;width:100%;">
    <div style="position:absolute;top:0;width: 100%;height: 100%;">
        <h1 class="title">异 享 天 眼 P C 登 录</h1>
        <div class="login">
            <h1>用 户 登 录</h1>
            <p class="p1">
                <img src="../assets/login_bgname.png" style="height: 100%;">
                <input type="txt" v-model="name" placeholder="账号">
            </p>
            <p class="p1">
                <img src="../assets/login_bgpwd.png" style="height: 100%;">
                <input type="password" v-model="pwd" placeholder="密码">
            </p>
            <p class="p2">
                <el-checkbox v-model="checked">记住密码</el-checkbox>
                <span style="float:right;color: #5ac1fe;">忘记密码？</span>
            </p>
            <button @click="login()">登录</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
        name:'',
        pwd:'',
        checked:false
    }
  },
    mounted(){
        if(JSON.parse(window.localStorage.getItem('user'))){
            var info = JSON.parse(window.localStorage.getItem('user'));
            this.name = info.name||'';
            this.pwd = info.pwd||'';
        }
        
    },
    methods:{
        login(){
            var _this = this;
            let param = new URLSearchParams();
            param.append("mobile", _this.name);
            param.append("password", _this.pwd);
            this.$http.post(api.user_login,param).then(function(res){
                if(res.data.code == 100001){
                    if(_this.checked){
                        var obj = new Object();
                        obj.name = _this.name;
                        obj.pwd = _this.pwd;
                        var a = JSON.stringify(obj);
                        window.localStorage.setItem('user',a);
                    }else{
                        window.localStorage.removeItem("user");
                    }
                    _this.$message({type: 'success',message: '登录成功!'});
                    setTimeout(()=>{
                        _this.$router.push({path:'/index'})
                    },1200)
                }
            }).catch((e) => {})
        }

    }
}
</script>
<style scoped>
.bg{
    text-align: center;
}
.bg div .title{
    padding-top: 10%;
    font-size: 2rem;
    color: #FFFFFF;
    font-weight: bold;
    padding-bottom: 6%;
}
.bg .login{
    width:25%;
    min-height:37%;
    display: inline-block;
    background:url("../assets/login_bglogin.png") no-repeat;
    background-size:100% 100%;
    padding-top:3%;
}
.bg .login>h1{
    font-size: 2rem;
    color: #FFFFFF;
}
.bg .login .p1{
    margin-top: 5%;
    width: 74%;
    height: 50px;
    box-sizing: border-box;
    margin-left: 13%;
    text-align: left;
    background:#FFFFFF;
    padding: 15px 10px;
}
.bg .login .p1 input{
    width:70%;
    height: 100%;
    vertical-align: top;
    margin-left: 10px;
    outline: none;
}
.bg .login .p2{
    margin-top: 3vh;
    width: 74%;
    box-sizing: border-box;
    margin-left: 13%;
    text-align: left;
    color:#FFFFFF;
}
.bg .login .p2 input{
    position: relative;
    top: 2px;
}
button{
    width: 57%;
    height: 45px;
    color: #FFFFFF;
    box-sizing: border-box;
    margin: 3vh 10% 5vh;
    background: -webkit-linear-gradient(#00e6fc, #0bc5d4); 
	background: -o-linear-gradient(#00e6fc, #0bc5d4); 
	background: -moz-linear-gradient(#00e6fc, #0bc5d4); 
	background: linear-gradient(#00e6fc, #0bc5d4); 
    outline: none;
    border: none;
    font-weight: bold; 
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue